module.exports = __webpack_public_path__ + "img/hr-rock-big-09.e382adcd.png";